import React from "react";
import { FaBell, FaTrash } from "react-icons/fa";

import {
  formatNotificationDate,
  getCategoryLabel,
  getCategoryStyle,
} from "../utils/notificationListUtils";

function NotificationMobileList({ notifications = [], deletingId, onDelete }) {
  return (
    <section className="space-y-3 lg:hidden">
      {notifications.map((notification) => {
        const style = getCategoryStyle(notification.category);
        const isDeleting = deletingId === notification.id;

        return (
          <article
            key={notification.id}
            className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
          >
            <div className="flex items-start gap-3">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
                <FaBell />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex min-h-8 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${style.badge}`}
                  >
                    <span className={`h-2 w-2 rounded-full ${style.dot}`} />
                    {getCategoryLabel(notification.category)}
                  </span>

                  <span className="text-xs font-bold text-slate-400">
                    {formatNotificationDate(notification.created_at)}
                  </span>
                </div>

                <p className="mt-3 whitespace-pre-line text-sm font-semibold leading-6 text-slate-700 dark:text-white/70">
                  {notification.message || "Notification sans message"}
                </p>

                <button
                  type="button"
                  onClick={() => onDelete(notification)}
                  disabled={isDeleting}
                  className="mt-4 inline-flex min-h-10 w-full items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                >
                  <FaTrash />
                  {isDeleting ? "Suppression..." : "Supprimer"}
                </button>
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}

export default NotificationMobileList;